export const windowPositionOptions = [
  { text: 'Absolute', value: 'ABSOLUTE' },
  { text: 'Relative', value: 'RELATIVE' },
] as const;
export const PositionList = windowPositionOptions.map((x) => x.value);
export type Position = typeof windowPositionOptions[number]['value'];
